import React, { Component } from 'react';
import moment from 'moment';

import './wrapper-search-box.style.css';
import DatePicker from 'react-date-picker';

export class WrapperSearchBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateSearch: new Date(),
            monthSearch: moment(new Date()).format('MM'),
            yearSearch: moment(new Date()).format('yyyy')
        }

        this.searchNow();
    }

    onChange = dateInput => {
        const monthSearch = moment(dateInput).format('MM');
        const yearSearch = moment(dateInput).format('yyyy');
        this.setState({ dateSearch : dateInput, monthSearch, yearSearch });
    }

    searchNow = () => {
        const {monthSearch,yearSearch} = this.state;
        this.props.searchFromParent(monthSearch,yearSearch);
    }

    render() {
        return (
            <div className="wrapper-search-box">
                <h1 className="name-element-search-box">Search Box</h1>
                {/* <p className="search-box-title-search">Select month and year, which you want to view, by default, we show you last month</p> */}
                <div className="container-for-datepicker-button">
                    <DatePicker
                        onChange={this.onChange}
                        value={this.state.dateSearch}
                        className="container-date-picker-component"
                        // format="MM-y"
                        // minDetail="year"
                        // defaultView="year"
                        maxDetail="year"
                    />
                    <button className="pipeline-button-search" onClick={this.searchNow}>
                        <p className="pipeline-button-search-text-inside">Search now</p>
                    </button>
                </div>
            </div>
        )
    }
}

export default WrapperSearchBox
